export default "__VITE_ASSET__DrNvemdv__"